export enum PurchasePath {
    BuyNCache = "Request Quotation",
    CreateQuotation = "Create Quotation",
    AlreadyCreated = "Purchase Quotation"
}